(function(){
'use strict';
var D = window.PN_CATALOG, G = D.genres, T = D.tags, TP = D.tagParents, R = D.recs, U = D.unfiled;
var SHOP = '/products/';
var UNF = G.length, ALL = G.length + 1; // pseudo-genres: "not yet sorted", "all records"

var st = { g: null, t: null, list: false, stock: true, q: '', sort: 'artist', shown: 0 };
var $ = function(id){ return document.getElementById(id); };
var cat = $('pnc-cat');
var fmt = function(n){ return n.toLocaleString('en-US'); };
var slug = function(s){ return s.toLowerCase().replace(/″/g,'in').replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); };
var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };
var GS = G.map(slug), TS = T.map(slug);

/* ——— the Catalog owns this page's URL ———
   Traced 2026-09-26, not guessed: scrolling this page fires
   history.replaceState from _0x109751 in
   cdn.shopify.com/extensions/…/infinite-scroll-148/assets/infinitescroll.min.js,
   and the URL it writes is our own with the '#' simply removed —
     /collections/all#/ebm-industrial/all  ->  /collections/all/ebm-industrial/all
   which is not a collection route and answers **404**, so a link copied or
   reloaded after a scroll is dead rather than merely reset.

   The app's files and settings are not touched. This only refuses history
   writes that would move this page off the route the Catalog is showing, and
   only while the Catalog actually owns a route (a '#/' hash on the Catalog
   page). Everything else passes straight through: the facet forms' own
   pushState on ?filter views, the search page, every other template, and the
   app's loading behaviour, which does not depend on these calls. */
(function guardRoute(){
  if (!cat || !window.history || !history.pushState) return;
  var ours = function(){ return location.hash.indexOf('#/') === 0; };
  var wrap = function(name){
    var orig = history[name];
    if (typeof orig !== 'function') return;
    history[name] = function(state, title, url){
      if (ours() && url != null){
        var u;
        try { u = new URL(String(url), location.href); } catch (e) { u = null; }
        /* a write that drops our route or moves the path is the corruption */
        if (!u || u.pathname !== location.pathname || u.hash !== location.hash) return;
      }
      return orig.apply(history, arguments);
    };
  };
  wrap('pushState'); wrap('replaceState');
})();

/* ——— counting ——— */
function pool(){ return st.stock ? R.filter(function(r){ return r.s; }) : R; }
function unfiledPool(){ return st.stock ? U.filter(function(r){ return r.s; }) : U; }
var C = {};
function recount(){
  var p = pool(), gc = G.map(function(){ return 0; }), tc = G.map(function(){ return {}; }), pair = {};
  p.forEach(function(r){
    r.m.forEach(function(g){
      gc[g]++;
      r.g.forEach(function(t){ if (TP[t].indexOf(g) >= 0) tc[g][t] = (tc[g][t] || 0) + 1; });
    });
    for (var i = 0; i < r.m.length; i++) for (var j = i + 1; j < r.m.length; j++){
      var a = Math.min(r.m[i], r.m[j]), b = Math.max(r.m[i], r.m[j]), k = a + ':' + b;
      pair[k] = (pair[k] || 0) + 1;
    }
  });
  C = { total: p.length, gc: gc, tc: tc, pair: pair, unf: unfiledPool().length };
}
function tagsOf(g){
  var c = C.tc[g];
  return Object.keys(c).map(Number).sort(function(a, b){ return c[b] - c[a] || (T[a] < T[b] ? -1 : 1); });
}

/* ——— the globe (Rue, 2026-09-17: "A · Globe" on desktop and phone) ———
   Genres, or one genre's tags, sit evenly on a sphere (Fibonacci spacing) with a
   thin spoke each back to the centre. Nearer = bigger and darker. Drag to spin
   (with inertia), scroll to turn, hover a label to hold it still; left alone it
   keeps turning slowly, like the product page. Tapping a genre shows its tags,
   tapping a tag opens those records, the centre goes back up a level. */
var stage = $('pnc-stage'), svg = $('pnc-map'), layer = $('pnc-layer'), hub = $('pnc-hub'), hubMain = $('pnc-hubMain'), hubBack = $('pnc-hubBack'),
    NS = 'http://www.w3.org/2000/svg';
var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var clamp = function(v, a, b){ return v < a ? a : v > b ? b : v; };
var ease = function(x){ return 1 - Math.pow(1 - x, 3); };
var small = function(){ return stage.clientWidth < 760 || document.documentElement.classList.contains('pn-phone'); };
var nodes = [], lines = [], globeKey = '', W = 0, H = 0;
/* Rue, 2026-09-19: the globe turns for ever on both axes. Pitch used to be
   clamped to +/-1.25 rad, so a vertical scroll ran out after part of a turn
   and you had to scroll back the other way. Both angles are now wrapped into
   (-PI, PI] instead of stopped, and the idle drift takes the short way home. */
var TAU = Math.PI * 2;
function wrap(a){ a = (a + Math.PI) % TAU; if (a < 0) a += TAU; return a - Math.PI; }
var yaw = 0.5, pitch = -0.3, vx = 0, vy = 0;
var dragging = false, hovering = null, idleSince = performance.now() - 5000, introAt = performance.now();

/* The one source of truth for a section's items: the All row, then its tags in
   the order tagsOf() gives them, each carrying its own count and its own act().
   globeItems() caps this for the sphere; the list shows all of it. Sharing the
   act() closures is what guarantees a tag goes to the same place either way. */
function sectionItems(){
  var g = st.g, tags = tagsOf(g);
  return [{ label: 'All ' + G[g], count: C.gc[g], all: true, act: function(){ go(g, null, true); } }]
    .concat(tags.map(function(t){
      return { label: T[t], count: C.tc[g][t], t: t, act: function(){ go(g, t, true); } };
    }));
}
function globeItems(){
  var max;
  if (st.g == null){
    return G.map(function(n, i){ return { label: n, count: C.gc[i], act: function(){ go(i, null); }, g: i }; });
  }
  var g = st.g, cap = small() ? 34 : 40;
  var arr = sectionItems();
  if (arr.length > cap){
    var rest = arr.length - (cap - 1);
    arr = arr.slice(0, cap - 1);
    arr.push({ label: '+' + rest + ' more tags', count: null, more: true, act: function(){ go(g, null, true); } });
  }
  return arr;
}
/* ——— the same section, as text ———
   One bounded scale for the name: rel = sqrt(count / biggest tag), so size rises
   with the count and never falls, equal counts always land on the same size, the
   biggest tag is only `span` px above the smallest, and a tag with one record
   still sits at the floor and stays readable. The count is printed beside every
   row at a fixed size, so nothing depends on reading the type. */
var viewMode = 'globe';
function drawTagList(){
  var wrap = $('pnc-taglist'); if (!wrap || st.g == null) return;
  var items = sectionItems();
  var max = Math.max.apply(null, items.map(function(i){ return i.all ? 0 : (i.count || 0); })) || 1;
  var sm = window.innerWidth < 760;            /* not small(): the stage may be hidden */
  var lo = sm ? 14 : 15, span = sm ? 9 : 13;
  var ul = document.createElement('ul'); ul.className = 'tl';
  items.forEach(function(it){
    var li = document.createElement('li'), b = document.createElement('button');
    if (it.all) li.className = 'all';   /* the row spans every column */
    b.type = 'button';
    b.className = 'tli' + (it.all ? ' all' : '') +
      (it.t != null && it.t === st.t ? ' on' : '') + (it.count === 0 ? ' zero' : '');
    if (!it.all){
      var rel = it.count > 0 ? Math.sqrt(Math.min(it.count, max) / max) : 0;
      b.style.fontSize = (lo + span * rel).toFixed(1) + 'px';
    }
    b.innerHTML = '<span class="n">' + esc(it.label) + '</span>' +
                  '<span class="c">' + fmt(it.count) + '</span>';
    b.setAttribute('aria-label', it.label + ', ' + it.count + (st.stock ? ' in stock' : ' records'));
    b.addEventListener('click', it.act);
    li.appendChild(b); ul.appendChild(li);
  });
  wrap.innerHTML = ''; wrap.appendChild(ul);
}
function setMode(m){
  if (viewMode === m) return;
  viewMode = m;                                 /* no state but the view changes */
  $('pnc-modeGlobe').setAttribute('aria-pressed', m === 'globe' ? 'true' : 'false');
  $('pnc-modeList').setAttribute('aria-pressed', m === 'list' ? 'true' : 'false');
  render();
}
function buildGlobe(){
  layer.innerHTML = ''; hovering = null;
  var items = globeItems(), N = items.length, sm = small();
  var max = Math.max.apply(null, items.map(function(i){ return i.all ? 0 : (i.count || 0); })) || 1;
  nodes = items.map(function(it, i){
    var b = document.createElement('button'); b.type = 'button';
    b.className = 'it' + (it.more ? ' more' : '') + (it.all ? ' all' : '') + (it.count === 0 ? ' zero' : '');
    var rel = it.count ? Math.sqrt(Math.min(it.count, max) / max) : 0.25;
    /* desktop sizes raised 2026-09-18 (Rue: "make the text much bigger") */
    var fs = st.g == null ? (sm ? 12 + 9 * rel : 20 + 22 * rel) : (sm ? 10.5 + 8 * rel : 15 + 17 * rel);
    if (it.all) fs = sm ? 17 : 26;
    b.style.fontSize = fs.toFixed(1) + 'px';
    b.innerHTML = '<span class="n">' + esc(it.label) + '</span>' + (it.count != null ? '<span class="c">' + fmt(it.count) + '</span>' : '');
    b.setAttribute('aria-label', it.label + (it.count != null ? ', ' + it.count + (st.stock ? ' in stock' : ' records') : ''));
    layer.appendChild(b);
    var y = 1 - 2 * (i + 0.5) / N, r = Math.sqrt(1 - y * y), th = i * 2.399963;
    var node = { el: b, it: it, bw: 0, bh: 0, p: [Math.cos(th) * r, y, Math.sin(th) * r] };
    b.__node = node;
    b.addEventListener('pointerenter', function(){ hovering = node; });
    b.addEventListener('pointerleave', function(){ if (hovering === node) hovering = null; });
    b.addEventListener('focus', function(){ hovering = node; });
    b.addEventListener('blur', function(){ if (hovering === node) hovering = null; });
    /* keyboard only: pointer taps are resolved in pointerup, so a mouse click must not fire twice */
    b.addEventListener('click', function(e){ if (e.detail === 0) it.act(); });
    return node;
  });
  measure();
  hubMain.innerHTML = st.g == null
    ? '<span class="hn">All</span><span class="hc">' + fmt(C.total + C.unf) + '</span>'
    : '<span class="hn">' + esc(G[st.g].split(' / ')[0]) + '</span><span class="hc">' + fmt(C.gc[st.g]) + '</span>';
  hubMain.setAttribute('aria-label', st.g == null ? 'All records' : 'All ' + G[st.g]);
  hubBack.hidden = st.g == null;
  hubBack.setAttribute('aria-label', 'Back to all genres');
  /* same caption as before on desktop; phones have no rail, so the unsorted records are linked here */
  /* no instructions on the page (Rue, 2026-09-18: "people will find out themselves");
     phones have no rail, so the unsorted records are linked here */
  $('pnc-caption').innerHTML = sm && st.g == null && C.unf ? '<a href="#/not-yet-sorted">' + fmt(C.unf) + ' not yet sorted →</a>' : '';
  introAt = performance.now();
}
function measure(){ nodes.forEach(function(n){ n.bw = n.el.offsetWidth; n.bh = n.el.offsetHeight; }); }
function showGlobe(){
  var key = (st.g == null ? 'root' : 'g' + st.g) + ':' + st.stock + ':' + small();
  if (key === globeKey) return;
  var first = !globeKey; globeKey = key;
  if (first || REDUCE){ buildGlobe(); return; }
  layer.classList.add('out');
  setTimeout(function(){ buildGlobe(); layer.classList.remove('out'); }, 240);
}
function tap(el, raw){
  if (!el) return;
  /* Rue, 2026-09-26: inside a section the centre used to go to '#/', the root
     globe — so tapping "EBM / Industrial" landed on All records, losing the
     section. It now opens that section's whole set, the identical call the
     section's own "All EBM / Industrial" node makes (globeItems: go(g, null,
     true) -> #/<section>/all), so both paths give the same list and the same
     count. At the root the centre still opens All records. Going back up a
     level is still the breadcrumb and the rail. */
  if (el === hubMain){
    if (st.g == null){ location.hash = '#/all'; return; }
    go(st.g, null, true);
    return;
  }
  if (el === hubBack){ location.hash = '#/'; return; }
  if (el.__node) el.__node.it.act();
}

var px = 0, py = 0, moved = 0;
stage.addEventListener('pointerdown', function(e){
  if (e.button > 0 || e.target.closest('.caption a')) return;
  dragging = true; moved = 0; px = e.clientX; py = e.clientY; vx = vy = 0;
  try { stage.setPointerCapture(e.pointerId); } catch (err) {}
});
stage.addEventListener('pointermove', function(e){
  if (!dragging) return;
  var dx = e.clientX - px, dy = e.clientY - py, sm = small(); px = e.clientX; py = e.clientY;
  moved += Math.abs(dx) + Math.abs(dy);
  vx = dx * (sm ? 0.0085 : 0.0075); vy = dy * (sm ? 0.0065 : 0.006);
  yaw += vx; pitch += vy;
  idleSince = performance.now();
});
stage.addEventListener('pointerup', function(e){
  if (!dragging) return; dragging = false; idleSince = performance.now();
  if (moved < 6){ var hit = document.elementFromPoint(e.clientX, e.clientY); tap(hit && hit.closest ? hit.closest('.it,.hubmain,.hb') : null, hit); }
});
stage.addEventListener('pointercancel', function(){ dragging = false; });
hubMain.addEventListener('click', function(e){ if (e.detail === 0) tap(hubMain, e.target); });
hubBack.addEventListener('click', function(e){ if (e.detail === 0) tap(hubBack, e.target); });
/* Rue, 2026-09-19: an Apple mouse or trackpad reports both axes at once, so the
   globe turns about the axis lying across the scroll — a scroll up or down tips
   it over, a scroll left or right spins it, and a diagonal scroll turns it about
   the axis in between. It follows the fingers, exactly as a drag does. Wheels
   that report lines or pages are converted to pixels first. */
stage.addEventListener('wheel', function(e){
  e.preventDefault(); idleSince = performance.now();
  var u = e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? stage.clientHeight : 1);
  var dx = -e.deltaX * u, dy = -e.deltaY * u;
  yaw += dx * 0.0032; pitch += dy * 0.0028;
}, { passive: false });
stage.addEventListener('keydown', function(e){
  if (e.key === 'ArrowLeft'){ yaw -= 0.3; idleSince = performance.now(); }
  if (e.key === 'ArrowRight'){ yaw += 0.3; idleSince = performance.now(); }
  if (e.key === 'Escape' && st.g != null) location.hash = '#/';
});
/* the rail and the globe are one control: pointing at a genre in the rail lights it on the globe */
$('pnc-rail').addEventListener('pointerover', function(e){
  var b = e.target.closest('button[data-g]'); if (!b || st.g != null) return;
  var g = +b.dataset.g; nodes.forEach(function(n){ if (n.it.g === g) hovering = n; });
});
$('pnc-rail').addEventListener('pointerleave', function(){ if (st.g == null) hovering = null; });

/* each spoke is solid at the centre and fades to nothing by the time it reaches
   its label (Rue, 2026-09-17): a gradient in user space from the hub to the label */
var defs = document.createElementNS(NS, 'defs'); svg.appendChild(defs);
function line(k){
  if (!lines[k]){
    var gr = document.createElementNS(NS, 'linearGradient');
    gr.id = 'pnc-sg' + k; gr.setAttribute('gradientUnits', 'userSpaceOnUse');
    gr.innerHTML = '<stop offset="0" stop-opacity="1"/><stop offset=".55" stop-opacity=".55"/><stop offset="1" stop-opacity="0"/>';
    defs.appendChild(gr);
    var l = document.createElementNS(NS, 'line'); l.setAttribute('stroke', 'url(#pnc-sg' + k + ')'); svg.appendChild(l);
    l.gr = gr; l.stops = gr.querySelectorAll('stop'); lines[k] = l;
  }
  return lines[k];
}
function spoke(l, x1, y1, x2, y2, hot){
  ['x1', 'y1', 'x2', 'y2'].forEach(function(a, i){ var v = [x1, y1, x2, y2][i].toFixed(1); l.setAttribute(a, v); l.gr.setAttribute(a, v); });
  var c = hot ? '#ff4400' : '#1c120b';
  if (l.col !== c){ l.col = c; for (var i = 0; i < l.stops.length; i++) l.stops[i].setAttribute('stop-color', c); }
}
function place(n, X, Y, s, op, z){
  var bw = n.bw * s;
  X = clamp(X, bw / 2 + 8, W - bw / 2 - 8);
  n.el.style.transform = 'translate(' + (X - n.bw / 2).toFixed(1) + 'px,' + (Y - n.bh / 2).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
  n.el.style.opacity = (n.it.count === 0 ? op * 0.4 : op).toFixed(3);
  n.el.style.zIndex = String(1000 + Math.round(z));
  n.el.style.pointerEvents = op < 0.28 ? 'none' : 'auto';
  n.el.tabIndex = op < 0.28 ? -1 : 0;
  n.el.classList.toggle('hot', hovering === n);
  n.X = X; n.Y = Y;
}
function frame(now){
  requestAnimationFrame(frame);
  if (document.hidden || st.list || !stage.offsetParent || !nodes.length) return;
  W = stage.clientWidth; H = stage.clientHeight;
  if (!W || !H) return;
  if (!nodes[0].bw) measure();
  var sm = small(), k = REDUCE ? 1 : ease(clamp((now - introAt) / 750, 0, 1));
  if (hovering) idleSince = now;                                  /* hovering a label holds the globe still */
  var idle = !dragging && now - idleSince > 2200 && !REDUCE, rest = sm ? -0.32 : -0.3;
  if (!dragging){ vx *= 0.95; vy *= 0.9; yaw += vx; pitch += vy; }
  if (idle){ yaw += sm ? 0.0022 : 0.0019; pitch += wrap(rest - pitch) * (sm ? 0.01 : 0.008); }
  yaw = wrap(yaw); pitch = wrap(pitch);
  var R = (sm ? Math.min(W * 0.38, H * 0.34) : Math.min(W * 0.33, H * 0.39)) * k;
  /* desktop: the globe is stretched sideways so the spokes reach out toward the sides of a wide screen */
  var SX = sm || !R ? 1 : clamp(W * 0.40 / R, 1, 2);
  var cx = W / 2, cy = H * (sm ? 0.47 : 0.52), F = sm ? 560 : 900;
  var cyw = Math.cos(yaw), syw = Math.sin(yaw), cp = Math.cos(pitch), sp = Math.sin(pitch), li = 0;
  nodes.forEach(function(n){
    var x = n.p[0] * R, y = n.p[1] * R, z = n.p[2] * R;
    var x1 = x * cyw + z * syw, z1 = -x * syw + z * cyw, y2 = y * cp - z1 * sp, z2 = y * sp + z1 * cp;
    var s = F / (F - z2), d = R ? (z2 / R + 1) / 2 : 1;
    place(n, cx + x1 * s * SX, cy + y2 * s, s * (0.7 + 0.3 * d), 0.14 + 0.86 * Math.pow(d, 1.4), z2);
    var l = line(li++), hot = hovering === n;
    spoke(l, cx, cy, n.X, n.Y, hot);
    l.setAttribute('stroke-width', (0.5 + 0.8 * d).toFixed(2));
    l.setAttribute('stroke-opacity', hot ? 0.9 : ((0.12 + 0.62 * d * d) * (n.it.count === 0 ? 0.4 : 1)).toFixed(3));
  });
  for (var j = li; j < lines.length; j++) lines[j].setAttribute('stroke-opacity', 0);
  hub.style.top = cy + 'px';
}
requestAnimationFrame(frame);

/* ——— rail + crumbs ——— */
function drawRail(){
  $('pnc-railSub').textContent = fmt(C.total) + (st.stock ? ' records in stock' : ' records');
  var h = '<li><button data-g="' + ALL + '" class="' + (st.g === ALL ? 'on' : '') + '"><span class="n">All records</span><span class="c">' + fmt(C.total + C.unf) + '</span></button></li><li class="gap"></li>';
  h += G.map(function(n, i){
    return '<li><button data-g="' + i + '" class="' + (st.g === i ? 'on' : '') + '"><span class="n">' + esc(n) + '</span><span class="c">' + fmt(C.gc[i]) + '</span></button></li>';
  }).join('');
  if (C.unf) h += '<li class="gap"></li><li><button data-g="' + UNF + '" class="muted' + (st.g === UNF ? ' on' : '') + '"><span class="n">Not yet sorted</span><span class="c">' + fmt(C.unf) + '</span></button></li>';
  $('pnc-rail').innerHTML = h;
}
function drawCrumbs(){
  var h = '';
  if (st.q){ h = '<button data-nav="home">Catalog</button><span class="sep">/</span><b>“' + esc(st.q) + '”</b>'; }
  else if (st.g == null){ h = '<b>All genres</b><span class="sep">·</span><a class="allgo" href="#/all">Browse all ' + fmt(C.total + C.unf) + (st.stock ? ' in stock' : ' records') + ' →</a>'; }
  else if (st.g === ALL){ h = '<button data-nav="home">All genres</button><span class="sep">/</span><b>All records</b>'; }
  else {
    h = '<button data-nav="home">All genres</button><span class="sep">/</span>';
    var gname = st.g === UNF ? 'Not yet sorted' : G[st.g];
    if (!st.list || st.g === UNF) h += '<b>' + esc(gname) + '</b>';
    else {
      h += '<button data-nav="genre">' + esc(gname) + '</button><span class="sep">/</span><b>' + (st.t == null ? 'All records' : esc(T[st.t])) + '</b>';
    }
  }
  $('pnc-crumbs').innerHTML = h;
}

/* ——— listing ——— */
var LIST = [], PAGE = 48;
/* the product page's own no-artwork sleeve, passed in from Liquid with its ?v= */
var BLANK = window.PN_BLANK_COVER || '';
/* closed on every fresh page load; kept open while filters are explored in place */
var tagsOpen = false;
function img(r){
  if (!r.i) return '';
  var u = /^https?:/.test(r.i) ? r.i : D.imgPrefix + r.i;
  return u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=360';
}
function drawList(){
  var rows;
  if (st.q){
    var q = st.q.toLowerCase();
    rows = pool().filter(function(r){ return (r.a + ' ' + r.t + ' ' + r.l).toLowerCase().indexOf(q) >= 0; })
      .concat(unfiledPool().filter(function(r){ return (r.t + ' ' + r.l).toLowerCase().indexOf(q) >= 0; }));
    $('pnc-lTitle').innerHTML = '<span>Search</span> ' + esc(st.q);
    $('pnc-lTags').innerHTML = '';
  } else if (st.g === ALL){
    rows = pool().concat(unfiledPool());
    $('pnc-lTitle').innerHTML = 'All records';
    $('pnc-lTags').innerHTML = '<button data-lg="' + ALL + '" class="on">All<i>' + fmt(C.total + C.unf) + '</i></button>' + G.map(function(n, i){
      return '<button data-lg="' + i + '">' + esc(n) + '<i>' + fmt(C.gc[i]) + '</i></button>';
    }).join('') + (C.unf ? '<button data-lg="' + UNF + '">Not yet sorted<i>' + fmt(C.unf) + '</i></button>' : '');
  } else if (st.g === UNF){
    rows = unfiledPool();
    $('pnc-lTitle').innerHTML = 'Not yet sorted';
    $('pnc-lTags').innerHTML = '<span style="font-weight:300;color:var(--ink2)">On the shop, but not filed under a genre yet.</span>';
  } else {
    var g = st.g, t = st.t;
    rows = pool().filter(function(r){ return r.m.indexOf(g) >= 0 && (t == null || r.g.indexOf(t) >= 0); });
    $('pnc-lTitle').innerHTML = esc(G[g]) + (t == null ? '' : ' <span>/ ' + esc(T[t]) + '</span>');
    var tags = tagsOf(g);
    $('pnc-lTags').innerHTML = tags.length ? '<button data-lt="" class="' + (t == null ? 'on' : '') + '">All<i>' + fmt(C.gc[g]) + '</i></button>' + tags.map(function(x){
      return '<button data-lt="' + x + '" class="' + (x === t ? 'on' : '') + '">' + esc(T[x]) + '<i>' + fmt(C.tc[g][x]) + '</i></button>';
    }).join('') : '';
  }
  var s = st.sort, name = function(r){ return (r.a || r.t || '').replace(/^the\s+/i, '').toLowerCase(); };
  rows = rows.slice().sort(function(a, b){
    if (s === 'lo') return (a.p == null) - (b.p == null) || a.p - b.p;
    if (s === 'hi') return (a.p == null) - (b.p == null) || b.p - a.p;
    if (s === 'new') return (+b.y || 0) - (+a.y || 0);
    if (s === 'old') return (+a.y || 9999) - (+b.y || 9999);
    return name(a) < name(b) ? -1 : name(a) > name(b) ? 1 : 0;
  });
  LIST = rows; st.shown = 0;
  $('pnc-lCount').innerHTML = fmt(rows.length) + '<small>' + (st.stock ? 'in stock' : 'records') + '</small>';
  $('pnc-grid').innerHTML = rows.length ? '' : '<div class="empty">Nothing here' + (st.stock ? ' in stock right now.' : '.') + '</div>';
  more();
  syncTags();
}
/* ——— the chip cloud, behind one toggle ———
   Counted off the buttons drawList() just wrote, never hard-coded: a genre
   index is 0..G.length-1, so UNF and ALL fall out of the count, and the "All"
   style button carries an empty data-lt. Search writes no buttons and the
   unfiled view writes a sentence rather than chips — neither is collapsible,
   so the toggle hides and the strip is left exactly as it was. */
function syncTags(){
  var strip = $('pnc-lTags'), btn = $('pnc-lTagsBtn');
  if (!strip || !btn) return;
  var bs = strip.getElementsByTagName('button'), styles = 0, genres = 0, i, v;
  for (i = 0; i < bs.length; i++){
    v = bs[i].getAttribute('data-lt');
    if (v != null){ if (v !== '') styles++; continue; }
    v = bs[i].getAttribute('data-lg');
    if (v != null && +v < G.length) genres++;
  }
  var n = styles || genres, word = styles ? 'Styles' : 'Genres';
  strip.classList.toggle('collapsible', n > 0);
  btn.hidden = !n;
  if (!n){ strip.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); return; }
  btn.innerHTML = '<span>' + word + ' (' + fmt(n) + ')</span>' +
    '<svg class="chev" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 6l5 5 5-5"/></svg>';
  strip.classList.toggle('open', tagsOpen);
  btn.setAttribute('aria-expanded', tagsOpen ? 'true' : 'false');
}
function more(){
  var h = '', end = Math.min(LIST.length, st.shown + PAGE);
  for (var i = st.shown; i < end; i++){
    var r = LIST[i], tg = (r.g || []).slice(0, 3);
    h += '<a class="card' + (r.s ? '' : ' sold') + '" href="' + SHOP + encodeURIComponent(r.h) + '" style="animation-delay:' + Math.min(600, (i - st.shown) * 14) + 'ms">' +
      '<div class="img">' + (r.i
        ? '<img loading="lazy" alt="' + esc((r.a ? r.a + ' – ' : '') + r.t) + '" src="' + esc(img(r)) + '">'
        : (BLANK ? '<img class="ph" loading="lazy" alt="" aria-hidden="true" src="' + esc(BLANK) + '">' : '')) + '</div>' +
      (r.a ? '<div class="a">' + esc(r.a) + '</div>' : '') + '<div class="t">' + esc(r.t) + '</div>' +
      '<div class="m"><span>' + esc([r.l, r.y].filter(Boolean).join(' · ')) + '</span><b>' + (r.s ? (r.p != null ? '$' + r.p.toFixed(2) : '') : 'Sold out') + '</b></div>' +
      (tg.length ? '<div class="tg">' + tg.map(function(t){ return '<button data-ct="' + t + '">' + esc(T[t]) + '</button>'; }).join(' · ') + '</div>' : '') +
      '</a>';
  }
  $('pnc-grid').insertAdjacentHTML('beforeend', h);
  st.shown = end;
  $('pnc-moreBtn').hidden = st.shown >= LIST.length;
  $('pnc-moreBtn').innerHTML = '<span>Show more records</span>' +
    '<span class="rest">' + fmt(LIST.length - st.shown) + ' left</span>';
}

/* ——— routing ——— */
function go(g, t, list){
  if (g == null){ location.hash = '#/'; return; }
  if (g === UNF){ location.hash = '#/not-yet-sorted'; return; }
  if (g === ALL){ location.hash = '#/all'; return; }
  var tagless = !tagsOf(g).length;
  if (list || tagless) location.hash = '#/' + GS[g] + '/' + (t == null ? 'all' : TS[t]);
  else location.hash = '#/' + GS[g];
}
function route(){
  var parts = location.hash.replace(/^#\/?/, '').split('/').filter(Boolean);
  st.q = ''; $('pnc-q').value = '';
  if (parts[0] === 'search'){ st.q = decodeURIComponent(parts[1] || ''); $('pnc-q').value = st.q; st.g = null; st.t = null; st.list = !!st.q; }
  else if (parts[0] === 'all'){ st.g = ALL; st.t = null; st.list = true; }
  else if (parts[0] === 'not-yet-sorted'){ st.g = UNF; st.t = null; st.list = true; }
  else {
    var g = GS.indexOf(parts[0]);
    st.g = g >= 0 ? g : null;
    st.t = null; st.list = false;
    if (st.g != null && parts[1]){ st.list = true; var t = TS.indexOf(parts[1]); st.t = t >= 0 ? t : null; }
  }
  render();
}
function render(){
  cat.classList.toggle('listing', st.list);
  drawRail(); drawCrumbs();
  /* the switch belongs to a section you are standing in, not to the root globe,
     the records list, or the unfiled pile */
  var sectionView = !st.list && st.g != null && st.g !== UNF && st.g !== ALL;
  var asList = sectionView && viewMode === 'list';
  $('pnc-modebar').hidden = !sectionView;
  $('pnc-taglist').hidden = !asList;
  $('pnc-stage').hidden = asList;
  if (st.list){ drawList(); window.scrollTo({ top: 0 }); }
  else if (st.g !== UNF && st.g !== ALL){
    if (asList) drawTagList(); else showGlobe();
  }
}

/* ——— events ——— */
document.addEventListener('click', function(e){
  var b = e.target.closest('button, a'); if (!b) return;
  if (b.dataset.tagtoggle != null){
    tagsOpen = !tagsOpen;
    var strip = $('pnc-lTags');
    if (strip) strip.classList.toggle('open', tagsOpen);
    b.setAttribute('aria-expanded', tagsOpen ? 'true' : 'false');
    return;
  }
  if (b.dataset.g != null && b.closest('.rail')){ var g = +b.dataset.g; go(g === st.g && !st.list ? null : g, null); return; }
  if (b.dataset.nav === 'home'){ location.hash = '#/'; return; }
  if (b.dataset.nav === 'genre'){ go(st.g, null); return; }
  if (b.dataset.lg != null){ var lg = +b.dataset.lg; go(lg, null, true); return; }
  if (b.dataset.lt != null){ go(st.g, b.dataset.lt === '' ? null : +b.dataset.lt, true); return; }
  if (b.dataset.t != null && b.closest('.more')){ go(st.g, +b.dataset.t, true); return; }
  if (b.dataset.ct != null){ e.preventDefault(); var t = +b.dataset.ct, home = st.g != null && st.g < UNF && TP[t].indexOf(st.g) >= 0 ? st.g : TP[t][0]; go(home, t, true); return; }
});
$('pnc-moreBtn').addEventListener('click', more);
$('pnc-modeGlobe').addEventListener('click', function(){ setMode('globe'); });
$('pnc-modeList').addEventListener('click', function(){ setMode('list'); });
$('pnc-sort').addEventListener('change', function(){ st.sort = this.value; drawList(); });
function toggleStock(){
  st.stock = !st.stock;
  ['pnc-stock', 'pnc-stockM'].forEach(function(id){ $(id).setAttribute('aria-checked', st.stock); });
  recount(); render();
}
$('pnc-stock').addEventListener('click', toggleStock); $('pnc-stockM').addEventListener('click', toggleStock);
var qt;
$('pnc-q').addEventListener('input', function(){
  var v = this.value.trim(); clearTimeout(qt);
  qt = setTimeout(function(){
    if (v.length >= 2) history.replaceState(null, '', '#/search/' + encodeURIComponent(v)), route();
    else if (st.q) { history.replaceState(null, '', '#/'); route(); }
  }, 180);
});
/* phones: the globe gets the rest of the screen under the header and the bar
   (at least 320px, so a landscape phone scrolls rather than squashing it) */
function fit(){
  if (window.matchMedia('(max-width:759px),(max-height:599px)').matches){
    var top = stage.getBoundingClientRect().top + window.scrollY;
    stage.style.height = Math.max(320, Math.round(window.innerHeight - top)) + 'px';
  } else stage.style.height = '';
  if (nodes.length && !st.list) measure();
  /* the list's type scale is chosen per width, so it follows a resize or rotate */
  if (!$('pnc-taglist').hidden) drawTagList();
}
window.addEventListener('resize', fit);
window.addEventListener('load', fit);
window.addEventListener('hashchange', route);

recount(); fit(); route(); fit();
})();
